<ng-container [ngSwitch]="case">
    <ng-container *ngSwitchCase="'job-card'">
        <div *ngFor="let item of items | times">
            <div class="skeleton-card">
                <div class="skeleton-header"></div>
                <div class="skeleton-title"></div>
                <div class="skeleton-subtext"></div>
                <div class="skeleton-subtext"></div>
                <div class="skeleton-footer">
                    <div class="skeleton-footer-item"></div>
                    <div class="skeleton-footer-item"></div>
                </div>
            </div>
        </div>

    </ng-container>

    <ng-container *ngSwitchCase="'job-card-page'">
        <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4" *ngFor="let item of items | times">
            <div class="skeleton-card" style="width: 100% !important;">
                <div class="skeleton-header"></div>
                <div class="skeleton-title"></div>
                <div class="skeleton-subtext"></div>
                <div class="skeleton-subtext"></div>
                <div class="skeleton-footer">
                    <div class="skeleton-footer-item"></div>
                    <div class="skeleton-footer-item"></div>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngSwitchCase="'directory'">
        <div class="company-skeleton-card" *ngFor="let item of items | times">
            <div class="company-skeleton-body">
                <div class="company-skeleton-header">
                    <!-- Logo tile skeleton (rounded square) -->
                    <div class="company-skeleton-logo"></div>

                    <div class="company-skeleton-content">
                        <div class="company-skeleton-name"></div>
                        <div class="company-skeleton-meta">
                            <div class="company-skeleton-meta-icon"></div>
                            <div class="company-skeleton-meta-text"></div>
                        </div>
                        <div class="company-skeleton-meta">
                            <div class="company-skeleton-meta-icon"></div>
                            <div class="company-skeleton-meta-text company-skeleton-meta-text--short"></div>
                        </div>
                        <div class="company-skeleton-meta">
                            <div class="company-skeleton-meta-icon"></div>
                            <div class="company-skeleton-meta-text"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="company-skeleton-footer">
                <div class="company-skeleton-footer-btn"></div>
                <div class="company-skeleton-footer-btn"></div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngSwitchCase="'job-candidate-detail'">
        <div class="skeleton-det-card-large">
            <div class="skeleton-det-top-row">
                <div class="skeleton-det-icon"></div>
                <div class="skeleton-det-title"></div>
                <div class="skeleton-det-badge"></div>
            </div>
            <div class="skeleton-det-header"></div>
            <div class="skeleton-det-section">
                <div class="skeleton-det-row"></div>
                <div class="skeleton-det-row"></div>
                <div class="skeleton-det-row"></div>
            </div>
            <div class="skeleton-det-buttons">
                <div class="skeleton-det-button"></div>
                <div class="skeleton-det-button"></div>
            </div>
            <div class="skeleton-det-divider"></div>
            <div class="skeleton-det-details">
                <div class="skeleton-det-detail-row"></div>
                <div class="skeleton-det-detail-row"></div>
            </div>
            <div class="skeleton-det-divider"></div>
            <div class="skeleton-det-details">
                <div class="skeleton-det-detail-row"></div>
                <div class="skeleton-det-detail-row"></div>
            </div>
            <div class="skeleton-det-divider"></div>
            <div class="skeleton-det-details">
                <div class="skeleton-det-detail-row"></div>
                <div class="skeleton-det-detail-row"></div>
            </div>
        </div>

    </ng-container>

    <ng-container *ngSwitchCase="'job-sidebar'">
        <!-- Apply card -->
        <div class="gjs-skel-card">
            <div class="gjs-skel-line gjs-skel-line--rate"></div>
            <div class="gjs-skel-line gjs-skel-line--sub"></div>
            <div class="gjs-skel-btn"></div>
            <div class="gjs-skel-btn-row">
                <div class="gjs-skel-btn gjs-skel-btn--sm"></div>
                <div class="gjs-skel-btn gjs-skel-btn--sm"></div>
            </div>
            <div class="gjs-skel-divider"></div>
            <div class="gjs-skel-line gjs-skel-line--meta"></div>
            <div class="gjs-skel-line gjs-skel-line--meta"></div>
            <div class="gjs-skel-line gjs-skel-line--meta"></div>
        </div>
        <!-- Company / recruiter card -->
        <div class="gjs-skel-card">
            <div class="gjs-skel-company">
                <div class="gjs-skel-avatar"></div>
                <div class="gjs-skel-company-text">
                    <div class="gjs-skel-line gjs-skel-line--name"></div>
                    <div class="gjs-skel-line gjs-skel-line--sub"></div>
                </div>
            </div>
            <div class="gjs-skel-divider"></div>
            <div class="gjs-skel-line gjs-skel-line--meta"></div>
            <div class="gjs-skel-line gjs-skel-line--meta"></div>
        </div>
    </ng-container>

    <ng-container *ngSwitchCase="'member-card'">
        <div class="member-skeleton-card" *ngFor="let item of items | times">
            <!-- Card Body -->
            <div class="member-skeleton-body">
                <div class="member-skeleton-header">
                    <!-- Logo/Avatar skeleton -->
                    <div class="member-skeleton-avatar"></div>

                    <!-- Text content -->
                    <div class="member-skeleton-content">
                        <div class="member-skeleton-name"></div>
                        <div class="member-skeleton-title"></div>
                        <div class="member-skeleton-title"></div>
                        <div class="member-skeleton-location">
                            <div class="member-skeleton-location-icon"></div>
                            <div class="member-skeleton-location-text"></div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Footer -->
            <div class="member-skeleton-footer">
                <div class="member-skeleton-footer-btn"></div>
                <div class="member-skeleton-footer-btn"></div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngSwitchCase="'pricing-card'">
        <div class="container-740"> 
            <!-- Tabs skeleton -->
            <div class="tabs-skeleton-740">
                <div class="tab-740 shimmer-740"></div>
                <div class="tab-740 shimmer-740"></div>
            </div>

            <!-- Toggle skeleton -->
            <div style="display: flex; justify-content: center; gap: 15px; margin-bottom: 40px;">
                <div class="shimmer-740" style="width: 60px; height: 20px; border-radius: 4px;"></div>
                <div class="shimmer-740" style="width: 80px; height: 30px; border-radius: 999px;"></div>
                <div class="shimmer-740" style="width: 80px; height: 20px; border-radius: 4px;"></div>
            </div>

            <!-- Pricing cards skeleton -->
            <div class="pricing-cards-740">
                <!-- Free Plan Card -->
                <div class="card-740">
                    <div class="card-title-740 shimmer-740"></div>
                    <div class="card-desc-740 shimmer-740"></div>
                    <div class="card-price-740 shimmer-740"></div>
                    <div class="card-price-subtitle-740 shimmer-740"></div>
                    <div class="card-button-740 shimmer-740"></div>
                    <div class="card-features-740">
                        <div class="feature-740">
                            <div class="feature-icon-740 shimmer-740"></div>
                            <div class="feature-text-740 shimmer-740"></div>
                        </div>
                        <div class="feature-740">
                            <div class="feature-icon-740 shimmer-740"></div>
                            <div class="feature-text-740 shimmer-740"></div>
                        </div>
                    </div>
                </div>

                <!-- Starter Plan Card -->
                <div class="card-740">
                    <div class="card-title-740 shimmer-740"></div>
                    <div class="card-desc-740 shimmer-740"></div>
                    <div class="card-price-740 shimmer-740"></div>
                    <div class="card-price-subtitle-740 shimmer-740"></div>
                    <div class="card-button-740 shimmer-740"></div>
                    <div class="card-features-740">
                        <div class="feature-740">
                            <div class="feature-icon-740 shimmer-740"></div>
                            <div class="feature-text-740 shimmer-740"></div>
                        </div>
                        <div class="feature-740">
                            <div class="feature-icon-740 shimmer-740"></div>
                            <div class="feature-text-740 shimmer-740"></div>
                        </div>
                    </div>
                </div>

                <!-- Growth Plan Card -->
                <div class="card-740">
                    <div class="card-title-740 shimmer-740"></div>
                    <div class="card-desc-740 shimmer-740"></div>
                    <div class="card-price-740 shimmer-740"></div>
                    <div class="card-price-subtitle-740 shimmer-740"></div>
                    <div class="card-button-740 shimmer-740"></div>
                    <div class="card-features-740">
                        <div class="feature-740">
                            <div class="feature-icon-740 shimmer-740"></div>
                            <div class="feature-text-740 shimmer-740"></div>
                        </div>
                        <div class="feature-740">
                            <div class="feature-icon-740 shimmer-740"></div>
                            <div class="feature-text-740 shimmer-740"></div>
                        </div>
                    </div>
                </div>

                <!-- Scale X Plan Card -->
                <div class="card-740">
                    <div class="card-title-740 shimmer-740"></div>
                    <div class="card-desc-740 shimmer-740"></div>
                    <div class="card-price-740 shimmer-740"></div>
                    <div class="card-price-subtitle-740 shimmer-740"></div>
                    <div class="card-button-740 shimmer-740"></div>
                    <div class="card-features-740">
                        <div class="feature-740">
                            <div class="feature-icon-740 shimmer-740"></div>
                            <div class="feature-text-740 shimmer-740"></div>
                        </div>
                        <div class="feature-740">
                            <div class="feature-icon-740 shimmer-740"></div>
                            <div class="feature-text-740 shimmer-740"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

</ng-container>